<script setup lang="ts">
import axios from 'axios';
import { onMounted, onUnmounted, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { inject } from 'vue';

const BACKEND_URL = inject('BACKEND_URL');
const router = useRouter();
const layout = ref('none');
const loading = ref(false);
const errorMessage = ref('');
const startupInfos = reactive({
    banners: [] as any[],
    top_categories: [] as any[],
    top_produits: [] as any[],
})

onMounted(() => {
  layout.value = router.currentRoute.value.meta.layout as string || 'none';
  doGetStartupInfos().then(() => {
    startAutoSlide();
  });
});

onUnmounted(() => {
  stopAutoSlide()
})

async function doGetStartupInfos() {
    try {
        loading.value = true;
        errorMessage.value = '';
        const httpResponse = await axios.get(`/market/startup_infos`);
        Object.assign(startupInfos, httpResponse.data);
    } catch(error: any) {
        errorMessage.value = error.message;
    } finally {
        loading.value = false;
    }
}

const current = ref(0);
let timer: any = null;
function goTo(index: number) {
    current.value = index;
    resetTimers();
}

function next() {
    current.value = (current.value + 1) % startupInfos.banners.length;
}

function startAutoSlide() {
  timer = setInterval(() => {
    next()
  }, 4000)
}

function stopAutoSlide() {
  if (timer) {
    clearInterval(timer)
  }
}

function resetTimers() {
    clearInterval(timer);
    timer = setInterval(() => {
        next()
    }, 4000);
}
</script>
<style scoped>
.carousel {
  position: relative;
  width: 900px;
  margin: auto;
}

.viewport {
  overflow: hidden;
}

.track {
  display: flex;
  transition: transform 0.4s ease;
}

.slide-carousel {
  width: 100%;
  flex-shrink: 0;
  height: 500px;
  object-fit: cover;
  border-radius: 60px;
}
</style>
<template>
    <main>

        <div class="page-space-25" v-if="layout == 'none'"></div>
        <div style="height: 300px; display: flex; justify-content: center; align-items: center;" v-if="loading">
            <div class="loader dark"></div>
        </div>
        <div v-if="!loading">
            <div class="carousel">
                <div class="viewport">
                    <div class="track" :style="{ transform: `translateX(-${current * 100}%)` }">
                        <img v-for="(banner, index) of startupInfos.banners" :key="index" :src="BACKEND_URL + '/assets/market_banners/1000/' + banner" class="slide-carousel" />
                    </div>
                </div>
                <div id="slider-nav-set">
                    <ul class="slider-nav-arrow">
                        <li class="slide" :class="{active: index === current}" v-for="(banner, index) of startupInfos.banners" :key="'banner_nav_' + index" @click="goTo(index)"></li>
                    </ul>
                </div>
            </div>
            <div class="clear-both h-30"></div>
            
            <div class="flex-center">
                <!--Card categorie-->
                <router-link :to="(layout == 'frontoffice' ? '/front/market/produits' : '/market/produits') + '?categorie=' + category.id" class="card-product px-5" style="width:12%;" v-for="(category, index) of startupInfos.top_categories" :key="'category_' + index">
                    <div class="img-area pb-1 px-4 py-4" style="background-color: rgba(var(--primary-color-rgb), 0.5); background: url('/public/images/bg-color-square.png'); background-size: cover;">
                        <img :src="BACKEND_URL + '/assets/market_categories/300/' + category.image" class="img mt-3" />
                        <h5 class="secondary-font text-black mt--4 mb-3">{{ category.nom }}</h5>
                    </div>
                </router-link>
                <!---->
            </div>
            <div class="clear-both h-20"></div>

            <section class="container-small">        
                <h1 class="secondary-font mb-6 text-center">Produits populaires</h1>

                <div class="grid-web3">

                    <market-card-product v-for="(item, index) in startupInfos.top_produits" :key="index" :produit="item" :layout="layout" />

                </div>

                <div class="clear-both h-30"></div>
                <div class="w-100p flex-center">
                    <router-link :to="layout == 'frontoffice' ? '/front/market/produits' : '/market/produits'">
                        <button class="btn grey">
                            <span>&nbsp; Voir plus de produits</span>
                            <img src="/public/icons/icon-arrow-right.svg" class="btn-icon icon-black ml-5 mr-0" alt="" />
                        </button>
                    </router-link>
                </div>
            </section>
        </div>

        <div class="clear-both h-60"></div>
    </main>
</template>